<template>
  <div class="nsale_ myPage_ poster_">
    <div class="list_">
      <div class="poster_outer">
        <img
          style="height: 100%;width: 100%;"
          v-if="step == '2'"
          class="poster_img"
          :src="uploadImg"
          alt="posterImg"
        />
        <div v-if="step == '2'" class="saveTip">
          <span>长按可保存海报</span>
        </div>
      </div>

      <div class="item_" id="posterHtml" v-if="step == '1'">
        <div class="item_1">
          <img class="item_1img" :src="postInfo.img" alt="poster" />
        </div>
        <div class="item_2">
          <img class="item_2img" :src="codeUrl" alt="poster" />
          <div class="invite-code">
            <p class="txt txt1">邀请码：</p>
            <!-- <p class="txt txt2">
              {{ postInfo.des }}
            </p> -->
            <p class="txt txt2">
              {{ postInfo.loginName }}
            </p>
          </div>
        </div>
      </div>

      <div class="item_" id="posterHtml" v-if="step == '3'">
        <div class="item_1">
          <img class="item_1img" :src="postInfo.img" alt="poster" />
          <!-- <img class="item_1img" src="../../../assets/image/nsale/post.jpg" alt="poster" />  -->
        </div>
        <div class="item_2">
          <div style="margin-left:10px;width: 215px;" v-if="showPoster">
            <div>邀请码</div>
            <cube-input
              class="inputStyle"
              v-model="postInfo.loginName"
              placeholder="请输入邀请码"
            ></cube-input>
          </div>
          <div class="invite-code" v-else>
            <p class="txt txt1">邀请码：</p>
            <p class="txt txt2">
              {{ postInfo.loginName }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- <cube-button class="btn_" @click="handle">完成</cube-button> -->
    <div v-if="step == '3'">
      <cube-button class="btn_" @click="handle">完成</cube-button>
    </div>
    <!-- <cube-button v-else class="btn_" @click="handleEdit">编辑海报</cube-button> -->

    <cube-button
      v-else
      id="copy"
      class="btn_"
      @click="shareRegisterLink"
      :data-clipboard-text="inviteRegisterLink"
      >分享注册链接</cube-button
    >
    <div v-if="showMask" class="mask" @click.self="showMask = false">
      <div class="mask-content">
        <p>链接已复制成功，可在聊天窗口粘贴，邀请用户注册</p>
        <button @click="showMask = false">确定</button>
      </div>
    </div>
  </div>
</template>

<script>
import html2canvas from "html2canvas";
import api from "@/utils/api";
import Clipboard from "clipboard";
export default {
  data() {
    return {
      inviteUrl: "",
      codeUrl: "",
      tempId: "",
      postInfo: {
        postImg: require("../../../assets/image/nsale/post.jpg"),
        name: "",
        des1: "",
        des2: "",
        loginName: ""
      },
      iosFirst: true, //ios系统生成海报偏移问题：ios第一次生成
      uploadImg: "", //上传后的链接地址
      posterImg: "", // 最终生成的海报图片
      showPoster: true,
      preview: true,
      step: "1",
      edit: false,
      inviteRegisterLink: "",
      clipboard: null,
      showMask: false
    };
  },
  mounted() {
    // this.hideOptionMenu();
    this.tempId = this.$route.params.id;
    this.edit = this.$route.meta.edit;
    console.log(this.edit, "-------", this.$route.params, this.$route.query);
    this.postInfo = JSON.parse(localStorage.getItem("postInfo") || '{}');
    this.queryLink();
    if (!this.edit && this.postInfo) {
      let st = setTimeout(() => {
        // this.createPoster();
        clearTimeout(st);
      }, 100);
      console.log("postInfo =>", this.postInfo);
    }
  },
  beforeRouteEnter(to, from, next) {
    console.log("beforeRouteEnter -->", to, from);
    next();
  },
  activated() {
    console.log("activated -> ", 1, this.$route);
  },
  methods: {
    queryLink() {
      let origin = "http://wx.run4wd.com";
      if (/ssish/.test(location.href)||/yutai365/.test(location.href)) {
        origin = "http://wx.ssish.com"
      }
      this.inviteRegisterLink = `${origin}/mnRegist?inviteCode=${this.postInfo.loginName}&appId=${localStorage.getItem("a_id")}`;
      this.getRegisterLinkToImg()
      this.$nextTick(function() {
        this.$forceUpdate();
      });
    },
    hideOptionMenu() {
      try {
        WeixinJSBridge.call("hideOptionMenu");
      } catch (error) {}
    },
    // handle() {
    //   this.iosFirst = false;
    //   this.showPoster = false;
    //   let st = setTimeout(() => {
    //     this.createPoster();
    //     clearTimeout(st);
    //   }, 500);
    // },
    // 邀请链接转二维码
    getRegisterLinkToImg() {
      import("jr-qrcode").then(jrQrcode => {
        // 模块方法调用，传入字符串，获取 base64 编码的图片 URL
        var imgBase64 = jrQrcode.getQrBase64(this.inviteRegisterLink);
        this.codeUrl = imgBase64;
        this.$nextTick(() => {
          this.createPoster()
        })
      });
    },
    base64(data) {
      api.base64(data).then(res => {
        this.uploadImg = res.data.content;
        this.step = "2";
      });
    },
    AndroisIos() {
      let u = navigator.userAgent;
      let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //g
      let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isAndroid) {
        return true;
      } else if (isIOS) {
        return false;
      }
    },
    createPoster() {
      // 生成海报
      let isAndroid = this.AndroisIos();
      let xNum = 0;
      if (isAndroid) {
        xNum = 15;
      } else if (this.iosFirst && !isAndroid) {
        xNum = 16;
      } else if (!this.iosFirst && !isAndroid) {
        xNum = 1;
      }
      // alert(isAndroid)
      console.log(isAndroid, window.scrollY);
      const vm = this;
      const domObj = document.getElementById("posterHtml");
      html2canvas(domObj, {
        useCORS: true,
        // timeout: 500, // 加载延时
        // backgroundColor: null,
        width: domObj.offsetWidth, // 下面解决当页面滚动之后生成图片出现白边问题
        height: domObj.offsetHeight,
        // windowWidth: document.body.scrollWidth,
        // windowHeight: document.body.scrollHeight,
        // scrollY: 0,
        // scrollX: 0,
        x: xNum,
        y: 10,
        dpi: window.devicePixelRatio * 2, // 解决图片不清晰问题
        scale: 2,
        logging: false,
        // letterRendering: true,
        onclone(doc) {
          let e = doc.querySelector("#posterHtml");
          e.style.display = "block";
        }
      }).then(function(canvas) {
        // 在微信里,可长按保存或转发
        vm.posterImg = canvas.toDataURL("image/png");
        // this.step = "2";
        let data = { base64Img: vm.posterImg };
        vm.base64(data);
      });
    },
    handleEdit() {
      this.step = "3";
      this.showPoster = true;
      // this.$router.push({ path: `/nsale/postEdit/${this.tempId}` });
    },
    // 分享注册链接
    shareRegisterLink() {
      const self = this
      this.clipboard = new Clipboard("#copy");
      this.clipboard.on("success", function(e) {
        self.clipboard = null;
        // 点击确定关闭弹窗
        self.showMask = true;
      });

      this.clipboard.on("error", function(e) {
        console.error("Action:", e.action);
        console.error("Trigger:", e.trigger);
        self.$toast("链接复制失败");
      });
    },
    
  }
};
</script>

<style scoped lang="scss">
.nsale_ {
  background: rgba(245, 245, 245, 1);
  min-height: 100vh;
  .btn_ {
    width: 305px;
    height: 50px;
    background: rgba(255, 74, 53, 1);
    border-radius: 5px;
    margin: 10px auto;
  }
  .list_ {
    margin: 0 auto 20px;
    height: 614px;
    width: 345px;
    padding-top: 10px;
    .item_ {
      // width: 345px;
      .item_1 {
        height: 500px;
        position: relative;
        .item_1img {
          width: 100%;
          height: 100%;
        }
      }
      .item_2 {
        background: url("../../../assets/image/BLogo.jpg") no-repeat;
        background-size: 100% 100%;
        height: 115px;
        display: flex;
        align-items: center;
        font-size: 14px;
        color: rgba(102, 102, 102, 1);
        padding: 10px;
        .item_2img {
          width: auto;
          height: 100px;
        }
        .invite-code {
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto;
        }
        .txt {
          text-align: left;
          font-size: 18px;
          font-weight: bold;
        }
        .txt1 {
          margin-right: 4px;
          color: #333333;
        }
        .txt2 {
          line-height: 20px;
          color: #409eff;
        }
      }
    }
  }

  .poster_outer {
    position: relative;
    .saveTip {
      position: absolute;
      left: 0;
      bottom: 120px;
      width: 345px;
      font-size: 11px;
      height: 25px;
      line-height: 25px;
      background: rgba(0, 0, 0, .6);
      display: flex;
      align-items: center;
      opacity: 1;
      justify-content: center;
      span {
        color: rgba(255, 255, 255, 1);
        opacity: 0.8;
      }
    }
  }

  .saveTip {
    width: 345px;
    font-size: 11px;
    height: 25px;
    line-height: 25px;
    background: rgba(0, 0, 0, 1);
    opacity: 0.4;
    position: absolute;
    bottom: 140px;
    left: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      color: rgba(255, 255, 255, 1);
      opacity: 0.5;
    }
  }
}
.mask {
  position: fixed;
  width: 100vw;
  height: 100vh;
  background: rgba(0,0,0,0.5);
  z-index: 99;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  .mask-content {
    width: 300px;
    background: #fff;
    border-radius: 15px;
    padding: 24px;
    color: #333333;
    line-height: 18px;
    font-size: 14px;
  }
  button {
    width: 100%;
    height: 36px;
    background: rgba(255, 74, 53, 1);
    border: 0;
    border-radius: 8px;
    margin-top: 16px;
    color: #fff;
    font-weight: 500;
  }
}
</style>
